import './PreventiveIssueDetails.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchViolationsDetails } from "../../../slices/violationsDetailsSlice";

const PreventiveIssueDetails = ({ id }) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const columns = useSelector((state) => state.violationsDetails.columns);
    const data = useSelector((state) => state.violationsDetails.data);

    useEffect(() => {
        dispatch(fetchViolationsDetails({ token, id }));
    }, [dispatch, token, id]);

    return (
        <div className="preventive-issue-details">
            <div className="preventive-issue-details_container">
                {columns.map((col) => {
                    const value = data?.attributes?.[col.key];

                    if (col.key === "clause_type_id") {
                        const link = data?.attributes?.clause_type_link;
                        return (
                            <div key={col.key} className="preventive-issue-details_field">
                                <div className="preventive-issue-details_title">{col.alias || col.name}</div>
                                <div className="preventive-issue-details_description">
                                    {link ? (
                                        <a
                                            href={link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="preventive-issue-details_link"
                                        >
                                            {value}
                                        </a>
                                    ) : (
                                        value
                                    )}
                                </div>
                            </div>
                        );
                    }

                    return (
                        <div key={col.key} className="preventive-issue-details_field">
                            <div className="preventive-issue-details_title">{col.alias || col.name}</div>
                            <div className="preventive-issue-details_description">{value}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PreventiveIssueDetails;